import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: { xs: 2, sm: 4 },
        pb: 'max(16px, env(safe-area-inset-bottom))',
        mt: 'auto',
        textAlign: 'center',
      }}
    >
      <Typography variant="body2" color="text.secondary">
        © {new Date().getFullYear()} . All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
